<template>
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6585 8.45831C11.0647 10.3214 9.36397 11.6666 7.35859 11.6666C4.85936 11.6666 2.83334 9.57731 2.83334 6.99998C2.83334 4.42265 4.85936 2.33331 7.35859 2.33331C9.03357 2.33331 10.496 3.27178 11.2784 4.66665M9.90405 5.24998H12.1667V2.91665"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
